import { t } from "@/i18n-js/instance";
import {
  annualDiscountPercentage,
  planAmountWithCurrencySuffix,
} from "@/react/helpers/planHelpers";
import type { Plan } from "@/react/types/Plan";
import { LineItem } from "./LineItem";

const localeRoot = "pricing_plans.plan_settings.plan_summary";

interface MonthlyLossProps {
  auxiliarySelectedPlan: Plan;
}

export const MonthlyLoss = ({ auxiliarySelectedPlan }: MonthlyLossProps) => (
  <LineItem
    description={t([localeRoot, "annual_savings"], {
      percentage: annualDiscountPercentage(auxiliarySelectedPlan),
    })}
    value={`-${planAmountWithCurrencySuffix(auxiliarySelectedPlan.annual_discount_amount_with_currency || "", auxiliarySelectedPlan.currency)}`}
    descriptionProps={{
      color: "text-red-500",
      textTransform: "line-through",
    }}
    valueProps={{ color: "text-red-500", textTransform: "line-through" }}
  />
);
